import { NgModule } from '@angular/core';
import { TranslateKeyPipe } from './translate-key/translate-key.pipe';
import { TranslateTextPipe } from './translate-text/translate-text.pipe';
import { FormatTranslatePipe } from './format-translate.pipe';

@NgModule({
  imports: [TranslateKeyPipe, TranslateTextPipe, FormatTranslatePipe],
  exports: [TranslateKeyPipe, TranslateTextPipe, FormatTranslatePipe],
})
export class PipesModule {}
